/* eslint-disable arrow-body-style */
import React from 'react';
import MaUTable from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableFooter from '@material-ui/core/TableFooter';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TablePaginationActions from './TablePaginationActions';
import TableRow from '@material-ui/core/TableRow';
import TableToolbar from './TableToolbar';
import {
    useGlobalFilter,
    usePagination,
    useRowSelect,
    useSortBy,
    useTable
} from 'react-table';

const EnhancedTable = ({
    columns,
    data,
    setModalTagsOpen,
    setModalNamesOpen,
    setModalOrdersOpen,
    style_rows
}) => {
    const {
        getTableProps,
        headerGroups,
        prepareRow,
        page,
        gotoPage,
        setPageSize,
        preGlobalFilteredRows,
        setGlobalFilter,
        state: {
            pageIndex,
            pageSize,
            selectedRowIds,
            globalFilter
        }
    } = useTable(
        {
            columns,
            data
        },
        useGlobalFilter,
        useSortBy,
        usePagination,
        useRowSelect
    );

    const handleChangePage = (event, newPage) => {
        gotoPage(newPage);
    };

    const handleChangeRowsPerPage = event => {
        setPageSize(Number(event.target.value));
    };

    // Render the UI for your table
    return (
        <TableContainer>
            <TableToolbar
                numSelected={Object.keys(selectedRowIds).length}
                preGlobalFilteredRows={preGlobalFilteredRows}
                setGlobalFilter={setGlobalFilter}
                globalFilter={globalFilter}
                setModalTagsOpen={setModalTagsOpen}
                setModalNamesOpen={setModalNamesOpen}
                setModalOrdersOpen={setModalOrdersOpen}
            />
            <MaUTable {...getTableProps()}>
                <TableHead>
                    {headerGroups.map((headerGroup, i) => (
                        <TableRow key={i} {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column, j) => (
                                <TableCell key={j} {...column.getHeaderProps({
                                    style: { minWidth: column.minWidth }
                                })}>
                                    {column.render('Header')}
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableHead>
                <TableBody>
                    {page.map((row, i) => {
                        prepareRow(row);

                        return (
                            <TableRow key={i} {...row.getRowProps()}>
                                {row.cells.map((cell, j) => {

                                    return (
                                        <TableCell key={j} style={{
                                            color: row.original.color,
                                            ...style_rows
                                        }} {...cell.getCellProps()}>
                                            {cell.render('Cell')}
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                        );
                    })}
                </TableBody>

                <TableFooter>
                    <TableRow>
                        <TablePagination
                            rowsPerPageOptions={[
                                5,
                                10,
                                25,
                                {
                                    label: 'All',
                                    value: data.length
                                }
                            ]}
                            colSpan={3}
                            count={data.length}
                            rowsPerPage={pageSize}
                            width={'100%'}
                            page={pageIndex}
                            SelectProps={{
                                inputProps: { 'aria-label': 'rows per page' },
                                native: true
                            }}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                            ActionsComponent={TablePaginationActions}
                        />
                    </TableRow>
                </TableFooter>
            </MaUTable>
        </TableContainer >
    );
};

export default EnhancedTable;
